/**
 * Fields that are dropdowns even when they are not define like that in the DB
 */
export const DROPDOWN_COLUMNS = ['targetTransmissionTenant', 'businessEntity'] as const;

/**
 * Fields that are dropdowns even when they are not define like that in the DB and the components need to be single with search
 */
export const DROPDOWN_COLUMNS_SINGLE = ['businessEntity'] as const;
